import { html, ref, when } from '@microsoft/fast-element';
import type { SectionHeader } from './section-header.js';

export default html<SectionHeader>`
	<slot name="badge"></slot>
	<slot></slot>
	<slot name="body"></slot>
	<slot name="action"></slot>
	<slot name="background"></slot>
`;